import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Checkbox,
    ListItemText,
    FormHelperText
} from '@mui/material';
import React from 'react';

const MultiSelectDropdown = ({
    id = 'Select',
    label = '',
    options = [],
    value = [],
    onChange,
    disabled = false,
    size = 'small',
    error = false,
    helperText = '',
    required,
    renderSelectedValues = (selected) => selected.join(", "),
    ...props
}) => {
    const labelId = `${id}-label`;
    const normalizedValue = Array.isArray(value)
      ? value.map((v) => String(v))
      : [];

    return (
        <FormControl
            fullWidth
            size={size}
            error={error}
        >
            <InputLabel
                id={labelId}
                shrink={normalizedValue.length > 0 ? true : undefined}
            >
                {label}{required && ' *'}
            </InputLabel>
            <Select
                labelId={labelId}
                multiple
                value={normalizedValue}
                onChange={onChange}
                label={label}
                disabled={disabled}
                displayEmpty
                notched={normalizedValue.length > 0 ? true : undefined}
                renderValue={(selected) => {
                  if (!selected || selected.length === 0) {
                    return "";
                  }
                  return renderSelectedValues(selected);
                }}
                {...props}
            >
                {options.map((option) => (
                    <MenuItem key={option.value} value={String(option.value)}>
                        <Checkbox
                          checked={normalizedValue.includes(String(option.value))}
                        />
                        <ListItemText primary={option.label} />
                    </MenuItem>
                ))}
            </Select>
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    );
};

export default MultiSelectDropdown;